import { render, staticRenderFns } from "./Healthcheck.vue?vue&type=template&id=74df9878&scoped=true&"
import script from "./Healthcheck.vue?vue&type=script&lang=js&"
export * from "./Healthcheck.vue?vue&type=script&lang=js&"
import style0 from "./Healthcheck.vue?vue&type=style&index=0&id=74df9878&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74df9878",
  null
  
)

export default component.exports